import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SessionService } from './session.service';

const SESSION_STORAGE_KEY = 'esign_session_id';

@Injectable({
  providedIn: 'root',
})
export class SessionInitializerService {
  private readonly sessionService = inject(SessionService);

  async initializeSession(participantId: string, signingId: string): Promise<string> {
    const storedSessionId = sessionStorage.getItem(SESSION_STORAGE_KEY);

    if (storedSessionId) {
      const validationResult = await firstValueFrom(
        this.sessionService.validateSession(storedSessionId, signingId, participantId),
      );

      if (validationResult.isValid) {
        return storedSessionId;
      }

      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }

    const createResult = await firstValueFrom(
      this.sessionService.createSession(participantId, signingId),
    );

    sessionStorage.setItem(SESSION_STORAGE_KEY, createResult.sessionId);

    return createResult.sessionId;
  }

  clearSession(): void {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  }

  getSessionId(): string | null {
    return sessionStorage.getItem(SESSION_STORAGE_KEY);
  }
}
